// Libs
import styled, { css } from 'styled-components'

// Comps
import { mobileScreen } from '../../utils'

export const safetyPageStyles = css`
  .BowedHero {
    margin-bottom: 120px;
    ${mobileScreen(
      css`
        margin-bottom: 60px;
      `,
    )}

    .heroText {
      max-width: 500px !important;
    }
  }
`
